import React from 'react';

import { useCurrentLanguage } from '@lib/hooks';
import { Language } from '@lib/resources/types';

import MaskedInput, { MaskedInputProps } from './MaskedInput';

export interface MaskedInputDateProps extends MaskedInputProps {}

function getPlaceholderBasedOnLanguage(language: Language) {
  switch (language) {
    case Language.Portuguese:
    case Language.Spanish:
      return 'mm-dd-aaaa';
    default:
      return 'mm-dd-yyyy';
  }
}

const MaskedInputDate: React.FC<MaskedInputDateProps> = (props) => {
  const language = useCurrentLanguage();

  return (
    <MaskedInput
      {...props}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholder={getPlaceholderBasedOnLanguage(language)}
      inputMode="numeric"
    />
  );
};

export default MaskedInputDate;
